import { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import { FOOTER_CREDIT } from './footerCredit'

/**
 * Chrome for the pages a signed-out visitor can see.
 *
 * Deliberately not the member Layout: no sidebar, no nav to pages they cannot
 * open, no install banner, no bingo easter egg. A stranger should see the
 * guild, not the tooling.
 */
export function PublicLayout({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-screen bg-raven-darker flex flex-col">
      <header className="border-b border-gray-800 bg-raven-dark/50 backdrop-blur sticky top-0 z-20">
        <div className="max-w-5xl mx-auto px-4 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <img src="/raven-logo.png" alt="" className="w-9 h-9 rounded-full object-cover" />
            <span className="font-bold text-gray-100 text-lg">Raven</span>
          </Link>
          <nav className="flex items-center gap-1">
            <a
              href="#apply"
              className="text-sm text-gray-400 hover:text-gray-100 transition-colors px-3 py-2"
            >
              Apply
            </a>
            <Link
              to="/login"
              className="text-sm text-gray-400 hover:text-gray-100 transition-colors px-3 py-2"
            >
              Member login
            </Link>
          </nav>
        </div>
      </header>

      <main className="flex-1">{children}</main>

      {/* Same footer as the member pages, minus the hidden bingo raven */}
      <footer className="border-t border-gray-800 px-4 md:px-6 py-3 text-center text-gray-600 text-sm">
        <span className="inline-flex flex-wrap items-center justify-center gap-x-1.5">
          <span>{FOOTER_CREDIT}</span>
          <span>Raven Guild v{__APP_VERSION__}</span>
        </span>
      </footer>
    </div>
  )
}
